import api from "../../utils/api";
import { AUDIT_TYPOLOGIES_URL } from "../../utils/endpoints";
import { Option } from "../../types/General/Option";

export async function getAuditTypologiesNonAdmin(): Promise<Option[]> {
  try {
    const response = await api.get(
      `${AUDIT_TYPOLOGIES_URL}?TypologiesForAdmin=false`,
    );

    const typologies = response?.data?.typologies ?? {};

    const data: Option[] = Object.entries(typologies).map(([key, value]) => ({
      id: key,
      name: String(value),
    }));
    return data;
  } catch (error) {
    throw error;
  }
}
